import React,{useEffect} from "react";
import { motion } from "framer-motion";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/contact-us-breadcrumb.webp';
import ContactSection from "../Components/ContactSection";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import contactPageSchema from "../Schema/ContactPageSchema";

const Contact=()=>{
    useEffect(() => {
                document.title =
                  "Contact Us | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Contact Iris Impulse India Pvt. Ltd. for product inquiries, pricing, or support. Our global team is ready to assist with your mineral supply needs worldwide."
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/contact-us");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Contact Us | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Contact Iris Impulse India Pvt. Ltd. for product inquiries, pricing, or support. Our global team is ready to assist with your mineral supply needs worldwide."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/contact-us");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/contact-us.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Contact Us | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Contact Iris Impulse India Pvt. Ltd. for product inquiries, pricing, or support. Our global team is ready to assist with your mineral supply needs worldwide."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/contact-us.webp"
                );
              }
              }, []);

    const fadeUp = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const organizationData = organizationSchema();
const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Contact Iris Impulse India Pvt. Ltd.",
    },
  ],
});
const contactPageData = contactPageSchema({
  url: "https://irisimpulse.com/contact-us",
  title: "Contact Us | Iris Impulse India Pvt. Ltd.",
  description: "Contact Iris Impulse India Pvt. Ltd. for product inquiries, pricing, or support. Our global team is ready to assist with your mineral supply needs worldwide.",
  image: "https://irisimpulse.com/Images/contact-us.webp",
});
    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={contactPageData} />

          <BreadCrumb
  title="Contact Us" 
  bgImage={bgImg} 
/>

       {/**CONTACT FORM SECTION */}
    <ContactSection />

    {/**LOCATION */}
    <section className="country-maps-section container">

  <motion.div
    className="country-maps-grid"
    variants={staggerContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >

    {/* MAP 1 */}

    <motion.div
      className="country-map-card"
      variants={fadeUp}
      whileHover={{
        y: -6,
      }}
      transition={{
        duration: 0.3,
      }}
    >

      <motion.h3
        className="section-subheading"
        variants={fadeUp}
      >
        Corporate Office
      </motion.h3>

      <motion.div
        className="country-map-frame"
        whileHover={{
          scale: 1.01,
        }}
        transition={{
          duration: 0.35,
        }}
      >

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3670.7411051452664!2d70.11477827571419!3d23.069951279140565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3950b9ee681b5efd%3A0x6d78c86c14afffa4!2sIRIS%20IMPULSE%20INDIA%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1779431036072!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{
            border: 0
          }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="India Office Location"
        ></iframe>

      </motion.div>

    </motion.div>

    {/* MAP 2 */}

    <motion.div
      className="country-map-card"
      variants={fadeUp}
      whileHover={{
        y: -6,
      }}
      transition={{
        duration: 0.3,
      }}
    >

      <motion.h3
        className="section-subheading"
        variants={fadeUp}
      >
        Manufacturing Plant Address
      </motion.h3>

      <motion.div
        className="country-map-frame"
        whileHover={{
          scale: 1.01,
        }}
        transition={{
          duration: 0.35,
        }}
      >

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3676.4779093311436!2d69.32844567570851!3d22.85879767928893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3951372d892fb8e1%3A0xc9263400bda50344!2sAshirwad%20Minechem!5e0!3m2!1sen!2sin!4v1779431087601!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{
            border: 0
          }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Vietnam Distribution Network"
        ></iframe>

      </motion.div>

    </motion.div>

  </motion.div>

</section>
        </>
    )
}
export default Contact;